import type dayjs from 'dayjs';
import { Model } from './model';
import { PaymentType } from './task_data';
import { TransformStringToDayJS } from './utils';

export enum PaymentPromiseSource {
  EMAIL = 'email',
  CALL = 'call',
  SMS = 'sms',
  USER = 'user',
  INTEGRATION_SYNC = 'integration_sync',
}

export class PaymentPromise extends Model {
  id: string;

  @TransformStringToDayJS()
  promised_to_pay_date: dayjs.Dayjs | null;

  source: PaymentPromiseSource | null;

  partner_id: string;

  invoice_id: string | null;

  email_id: string | null;

  call_id: string | null;

  sms_id: string | null;

  sms_thread_id: string | null;

  created_by_user_id: string | null;

  payment_type: PaymentType | null;

  @TransformStringToDayJS()
  sent_date: dayjs.Dayjs | null;

  amount: number | null;

  currency: string | null;

  is_calculated: boolean;

  agent_confidence_score: number | null;

  agent_confidence_reason: string | null;

  agent_uncertainties: string[];

  agent_error_code: string | null;

  extracted_invoice_number: string | null;

  is_promised_date_updated: boolean;

  outside_task_scope: boolean;

  unknown_invoice_number: boolean;
}
